const mbLearnLogo = '/mblearn-logo-HD.png';

export const MassageBeachBackground = () => {
  return (
    <div className="absolute inset-0 -z-10 overflow-hidden">
      {/* Background Logo */}
      <img
        src={mbLearnLogo}
        alt="MBLearn background"
        className="absolute inset-0 w-full h-full object-contain opacity-5"
        loading="eager"
      />
      
      {/* Gradient overlays for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-background/80 via-background/60 to-background/80" />
    </div>
  );
};
